import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page-title-bar" }
const _hoisted_2 = { style: {"margin":"0"} }
const _hoisted_3 = {
  key: 0,
  style: {"margin":"0"}
}

import { computed, useSlots } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'PageTitleBar',
  setup(__props) {

const slots = useSlots()
const screenWidth = computed(() => window.innerWidth)

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, {
          span: _unref(screenWidth) <= 1024 || !_unref(slots).buttons ? 24 : 10
        }, {
          default: _withCtx(() => [
            _createElementVNode("h2", _hoisted_2, [
              _renderSlot(_ctx.$slots, "title")
            ]),
            (_unref(slots).subtitle)
              ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
                  _renderSlot(_ctx.$slots, "subtitle")
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 3
        }, 8, ["span"]),
        (_unref(screenWidth) > 1024 && _unref(slots).buttons)
          ? (_openBlock(), _createBlock(_component_a_col, {
              key: 0,
              span: 14,
              class: "desktop-buttons"
            }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "buttons")
              ]),
              _: 3
            }))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }),
    (_unref(slots).search)
      ? (_openBlock(), _createBlock(_component_a_row, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 24 }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "search")
              ]),
              _: 3
            })
          ]),
          _: 3
        }))
      : _createCommentVNode("", true),
    (_unref(screenWidth) <= 1024 && _unref(slots).buttons)
      ? (_openBlock(), _createBlock(_component_a_row, { key: 1 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, {
              class: "mobile-buttons",
              span: 24
            }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "buttons")
              ]),
              _: 3
            })
          ]),
          _: 3
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})